'use strict';

angular.module('licensure.helpers')
    .filter('classification', ['$filter', function ($filter) {
        return function (items, classification, field) {

            var resetItems = items.filter(function (item) {
                if (item['activeservice'] == true) {
                    if (item['filtered'] == "Classification") {
                        item['disable'] = false;
                        item['filtered'] = null;
                    }
                }
                return item;
            });

            var filtered = resetItems.filter(function (resetItem) {
                if (resetItem['activeservice'] == true) {
                    if (field !== null && classification !== null) {
                        if (resetItem[field] !== classification) {
                            resetItem['disable'] = true;
                            resetItem['filtered'] = "Classification";
                        }
                    }
                }
                return resetItem['disable'] !== true ;
            });

            return filtered;
        }
    }])
    .filter('county', ['$filter', function ($filter) {
        return function (items, county, field) {
            var resetItems = items.filter(function (item) {
                if (item['activeservice'] == true) {
                    if (item['filtered'] == "County") {
                        item['disable'] = false;
                        item['filtered'] = null;
                    }
                }
                return item;
            });

            var filtered = resetItems.filter(function (resetItem) {
                if (resetItem['activeservice'] == true) {
                    if (field !== null && county !== null) {
                        // if county (the filter) is null, don't disable anything, otherwise check for equality
                        if (county !== null && resetItem[field] !== null && resetItem[field].toLowerCase() !== county.toLowerCase()) {
                            resetItem['disable'] = true;
                            resetItem['filtered'] = "County";
                        } else if (county !== null && resetItem[field] === null) {
                            resetItem['disable'] = true;
                            resetItem['filtered'] = "County";
                        }
                    }
                }
                return resetItem;
            });

            return filtered;
        }
    }])
    .filter('month', ['$filter', function ($filter) {
        return function (items, month, field) {
            if (month == null || field == null) {
                return items;
            }

            var filtered = [];
            for (var i = 0; i < items.length; i++) {
                var d = new Date($filter('date')(items[i][field], 'medium'));
                if (d.getMonth() == month) {
                    filtered.push(items[i]);
                }
            }
            return filtered;
        }
    }])
    .filter('year', ['$filter', function ($filter) {
        return function (items, year, field) {
            if (year == null || field == null) {
                return items;
            }

            var filtered = [];
            for (var i = 0; i < items.length; i++) {
                var d = new Date($filter('date')(items[i][field], 'medium'));
                if (d.getFullYear() == year) {
                    filtered.push(items[i]);
                }
            }
            return filtered;
        }
    }])
    .filter('days', ['Format', function (Format) {
        return function (input, days, field) {
            input = input || [];

            if (field == null || days == null)
                return input;

            var out = [];
            var now = new Date();
            input.forEach(function (item) {
                if (item != null) {
                    var value = item[field];
                    if (value != null && isValidDate(value)) {
                        var dayDiff = Math.round((now.getTime() - value.getTime()) / (24 * 60 * 60 * 1000));
                        if (dayDiff < 0) {
                            if (dayDiff >= days) {
                                out.push(item);
                            }
                        }
                        else {
                            if (days == 1 && dayDiff == 1) {
                                // special case for yesterday, to not include today  
                                out.push(item);
                            }
                            else if (days != 1 && dayDiff <= days) {
                                out.push(item);
                            }
                        }
                    }
                }
            });
            return out;
        }
    }])
    .filter('inspectionsFilter', function () {
        return function (visits, filterId, property) {
            if (filterId === null || filterId === undefined || filterId === '') {
                return visits;
            }

            var filtered = [];
            var filterIdLowercase = filterId.toLowerCase();
            visits.forEach(function (visit) {
                if (visit.inspections.some(function (inspection) { return inspection[property] !== null && inspection[property].id.toLowerCase() === filterIdLowercase })) {
                    //At least one inspection on the visit matches the filtered value
                    filtered.push(visit);
                }
            });

            return filtered;
        };
    })
    ;